import React from 'react';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import { BrowserRouter as Router,Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import {connect, setStore} from 'trim-redux'
import {defaultVariabls} from './config';
import Login from "./class/pages/Authentication/Login";
import Loader from "./class/components/elements/Loader";
import {theme} from './config/design/theme';
import {Styles} from "./config/design/styles";
import {SnackbarProvider} from "notistack";
import PrivateRoute from "./class/components/elements/PrivateRoute";
import Layout from "./class/components/layouts/layout";
import Error404 from './class/pages/errors/404';
import FileManagerPage from "./class/pages/fileManager/FileManagerPage";
import ChangePassword from "./class/pages/user/ChangePassword";
import Permission from "./class/components/elements/Permission";
import {ErrorBoundary} from 'react-error-boundary'
import IconButton from "@material-ui/core/IconButton/IconButton";
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import {Translate} from "./config/Translate";
import MakeContent from "./class/pages/contents/MakeContent";
import Contents from "./class/pages/contents/Contents";
import CategoriesPage from "./class/pages/admin/categories/CategoriesPage";
import MakeCategory from "./class/pages/admin/categories/MakeCategory";
import CommentsPage from "./class/pages/admin/comments/CommentsPage";
import ManageAbout from "./class/pages/admin/pages/ManageAbout";
import ManageTerms from "./class/pages/admin/pages/ManageTerms";
import ManageContact from "./class/pages/admin/pages/ManageContact";
import TranslateFront from "./class/pages/admin/settings/TranslateFront";
import UsersPage from "./class/pages/admin/users/UsersPage";
import AddUserPage from "./class/pages/admin/users/AddUserPage";
import ActivityLog from "./class/pages/admin/users/UsersLogPage";
import ProductsPage from "./class/pages/admin/products/ProductsPage";
import MakeProduct from "./class/pages/admin/products/MakeProduct";
import VariablesPage from "./class/pages/admin/variables/VariablesPage";
import MakeVariable from "./class/pages/admin/variables/MakeVariable";
import ManageOrdersPage from "./class/pages/admin/orders/ManageOrdersPage";
import Dashboard from "./class/pages/Dashboard/Dashboard";
import Logout from "./class/pages/Authentication/Logout";
import SafeCoinsPage from "./class/pages/admin/safecoin/SafeCoinsPage";
import ManageCurrenciesPage from "./class/pages/admin/settings/currencies/ManageCurrenciesPage";
import PlatformsPage from "./class/pages/admin/categories/PlatformsPage";
import MakePlatform from "./class/pages/admin/categories/MakePlatform";
import ManageHome from "./class/pages/admin/pages/ManageHome";
import ManageOrderDescription from "./class/pages/admin/pages/ManageOrderDescription";
import TagsPage from "./class/pages/admin/tags/TagsPage";
import MakeTag from "./class/pages/admin/tags/MakeTag";

class App extends React.Component{
    state ={
        loading:true
    };
    async componentDidMount(){

        await this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });
                    if(response.data.role.type !== "admin"){
                        window.location.href= defaultVariabls.website;
                    }
                    this.setState({
                        loading:false
                    })


                }).catch(error => {
                    setStore({
                        isAuth : false,
                        user : null,
                        loading:false
                    });
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    ErrorFallback({error}) {
        if(!!error){
            console.log(error)
            return (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={true}
                    message={Translate.errorHappens}
                    action={
                        <React.Fragment>
                            <IconButton  onClick={() => window.location.reload()}>
                                <CachedRoundedIcon color="secondary"/>
                            </IconButton>
                        </React.Fragment>
                    }
                />
            )
        }

    }
    classes = this.props.classes;
    render(){
        if(this.state.loading){
            return(
                <Loader/>
            )
        }else{
            return(
                <ThemeProvider theme={theme}>
                    <SnackbarProvider anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}>
                            <ErrorBoundary FallbackComponent={this.ErrorFallback}>
                                <Router>
                                    <Switch>
                                        <Redirect exact from='/' to='/dashboard'/>
                                        <Route  path="/notingFound" >
                                            <Error404/>
                                        </Route>
                                        {/*Auth Routes*/}
                                        <Route path="/login">
                                            <Login />
                                        </Route>
                                        <Layout>
                                            <PrivateRoute exact path="/logout">
                                                <Logout/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/dashboard">
                                                <Dashboard/>
                                            </PrivateRoute>
                                            <Permission rule="fileManagerPage">
                                                <PrivateRoute path="/file-manager">
                                                    <FileManagerPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <PrivateRoute path="/changePassword">
                                                <ChangePassword/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/news" exact>
                                                <Contents/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/news/make" exact>
                                                <MakeContent new/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/news/make/:id">
                                                <MakeContent />
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/manage/manage-comments">
                                                <CommentsPage/>
                                            </PrivateRoute>
                                            <Permission rule="manageSettings">
                                                <PrivateRoute exact path="/manage/manage-categories">
                                                    <CategoriesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/category">
                                                    <MakeCategory new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/category/:id">
                                                    <MakeCategory />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/manage-tags">
                                                    <TagsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/tag">
                                                    <MakeTag new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/tag/:id">
                                                    <MakeTag />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/manage-platforms">
                                                    <PlatformsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/platform/:id">
                                                    <MakePlatform />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/currencies">
                                                    <ManageCurrenciesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/about">
                                                    <ManageAbout/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/home">
                                                    <ManageHome/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/order_description">
                                                    <ManageOrderDescription/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/terms">
                                                    <ManageTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/contact">
                                                    <ManageContact/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/settings/translate-front">
                                                    <TranslateFront/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/users/view/:type?">
                                                    <UsersPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/users/add">
                                                    <AddUserPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/activities/:query?">
                                                    <ActivityLog/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="managePayments">
                                                <PrivateRoute exact path="/manage/orders">
                                                    <ManageOrdersPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/safe-coins/:type?">
                                                    <SafeCoinsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/products">
                                                    <ProductsPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/create/product" exact>
                                                    <MakeProduct new/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/edit/product/:id">
                                                    <MakeProduct />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/manage-variables">
                                                    <VariablesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/variable">
                                                    <MakeVariable new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/variable/:id">
                                                    <MakeVariable />
                                                </PrivateRoute>
                                            </Permission>
                                            <PrivateRoute path="/account/password">
                                                <ChangePassword/>
                                            </PrivateRoute>
                                        </Layout>

                                        {/*Errors Routes*/}
                                        <Route component={Error404} />
                                    </Switch>
                                </Router>
                            </ErrorBoundary>
                    </SnackbarProvider>
                </ThemeProvider>
            )
        }

    }

}
const mstp = state => ({
    user: state.user
});
export default withStyles(Styles)(connect(mstp)(App));
